export const FILE_LOADING = 'FILE_LOADING';
export const UPLOAD_SUCCESS = 'UPLOAD_SUCCESS';
export const UPLOAD_ERROR = 'UPLOAD_ERROR';
export const REMOVE_FILE = 'REMOVE_FILE';

export const MIN_IMAGE_UPLOAD_WIDTH = 640;
export const MIN_IMAGE_UPLOAD_HEIGHT = 360;
export const MAX_FILE_SIZE_MB = 5;
